import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accordionHeader', 'accordionContent'];

  static classes = ['selected'];

  connect() {
    this.closeAllAccordions();
    this.accordionHeaderTargets.forEach((header) => {
      header.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion = (event) => {
    const content = event.currentTarget.nextElementSibling;
    const open = JSON.parse(content.dataset.visible);
    const openIcon = event.currentTarget.querySelector('svg[data-icon="openIcon"]');

    if (open) {
      openIcon.classList.remove('rotate-180');
      event.target.classList.add(...this.selectedClasses);
    } else {
      openIcon.classList.add('rotate-180');
    }

    this.closeAllAccordions();

    content.dataset.visible = !open;
  };

  closeAllAccordions = () => {
    this.accordionContentTargets.forEach((content) => {
      if (content.dataset.visible === 'true') {
        content.parentElement.querySelector('button > svg')?.classList.remove('rotate-180');
      }
      content.dataset.visible = false;
    });
  };
}
